import React, { Fragment } from 'react'
import { bool, string } from 'prop-types'
import { connect } from 'react-redux'
import Button from 'common/components/button'
import { REGISTER_LINK, SIGNIN_LINK, BTC_REGISTER_LINK } from 'services/utility/constants'
import './index.scss'

const MobileProfile = ({
  isSignedIn,
  firstName,
  isBabyClubMember,
  isBabyClubHeader,
}) => (
  <div className="mobile-profile">
    {isSignedIn && (
      <Fragment>
        {
        (isBabyClubHeader && !isBabyClubMember) ?
          <Button
            href={BTC_REGISTER_LINK}
            className="full"
            category="secondary"
            asAnchor
          >
            Join Asda Baby club
          </Button> : <h3>Hi { firstName || 'there' }</h3>
        }
      </Fragment>
    )
    }
    { !isSignedIn ?
      (
        <Fragment>
          {!isBabyClubHeader &&
          <Button
            href={REGISTER_LINK}
            category="secondary"
            asAnchor
          >
            Register
          </Button>
          }
          <Button
            href={SIGNIN_LINK}
            className={isBabyClubHeader ? `full` : `mobile-right`}
            category="secondary"
            asAnchor
          >
            {isBabyClubHeader ? `Join Asda Baby club` : `Sign in`}
          </Button>
        </Fragment>
      ) : null
    }
  </div>
)

MobileProfile.propTypes = {
  isSignedIn: bool.isRequired,
  firstName: string,
  isBabyClubMember: bool.isRequired,
  isBabyClubHeader: bool,
}

MobileProfile.defaultProps = {
  firstName: '',
  isBabyClubHeader: false,
}

const mapStateToProps = ({ profile }) => {
  const {
    profile: { additionalInfo: { firstName } },
    isSignedIn,
    isBabyClubMember,
  } = profile
  return {
    isSignedIn,
    firstName,
    isBabyClubMember,
  }
}

export default connect(mapStateToProps)(MobileProfile)



// WEBPACK FOOTER //
// ./components/MobileProfile/index.js